import { Component, inject } from '@angular/core';
import { TransferTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TransferTypeCreateDto,
  TransferTypeDto,
  TransferTypeExcelDownloadDto,
  TransferTypeUpdateDto,
} from '../proxy/controlling/dtos/transfer-type';
import { TRANSFERTYPE_CONFIG, TRANSFERTYPE_FIELDS } from './transfer-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-transfer-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TransferTypeService, ConfirmationService],
  templateUrl: './transfer-type.html',
  styleUrl: './transfer-type.scss',
})
export class TransferType extends BaseCrudComponent<
  TransferTypeDto,
  TransferTypeCreateDto,
  TransferTypeUpdateDto,
  TransferTypeExcelDownloadDto
> {
  service = inject(TransferTypeService);
  config = TRANSFERTYPE_CONFIG;
  fields = TRANSFERTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: TransferTypeDto): TransferTypeUpdateDto {
    return {
      name: data.name,
      value: data.value,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TransferType';
  }
}
